import { useTranslation } from 'react-i18next';
import Button from 'components/Button/Button';
import Separator from 'components/Separator/Separator';
import { BUTTON_VARIANT } from 'constants/interfaces';

import type IImportErrorsModalFooter from './interfaces/IImportErrorsModalFooter';

import styles from './scss/ImportErrorsModalFooter.module.scss';

function ImportErrorsModalFooter({
  showButtons,
  onClose,
  onReplaceDuplicates,
  onSkipDuplicates,
}: IImportErrorsModalFooter) {
  const { t } = useTranslation();

  return (
    <>
      <Separator />
      <div className={styles.footer}>
        <div className={styles.buttonWrapper}>
          <Button
            title={t('common.close')}
            variant={BUTTON_VARIANT.cancel}
            onClick={onClose}
          />
          {showButtons ? (
            <>
              <Button
                title={t('common.replaceDuplicates')}
                variant={BUTTON_VARIANT.secondary}
                onClick={onReplaceDuplicates}
              />
              <Button
                title={t('common.skipDuplicates')}
                variant={BUTTON_VARIANT.primary}
                onClick={onSkipDuplicates}
              />
            </>
          ) : null}
        </div>
      </div>
    </>
  );
}

export default ImportErrorsModalFooter;
